import React from "react";
import { useTranslation } from "react-i18next";
import { Message, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { WebStorage, WebStorageNames } from "../../../utils";

/**
 * Component to show subscription restriction message
 * @param {Object} props
 * @param {string} props.actionKey - Translation key for the restricted action (e.g. "app.subscriptionRestriction.actionViewUsers")
 */
const SubscriptionRestriction = ({ actionKey = "app.subscriptionRestriction.actionPerformAction" }) => {
    const { t } = useTranslation();
    const actionText = t(actionKey);
    let roleId = null;
    try {
        roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
    } catch (e) {
        roleId = localStorage.getItem("roleId");
    }

    const isAdmin = roleId && (parseInt(roleId) === 1 || parseInt(roleId) === 2);

    return (
        <Message warning style={{ margin: "20px 0" }}>
            <Icon name="warning circle" />
            <Message.Header>{t("app.subscriptionRestriction.subscriptionNotActive")}</Message.Header>
            <Message.Content>
                <p>
                    {isAdmin
                        ? t("app.subscriptionRestriction.cannotUntilPayment", { action: actionText })
                        : t("app.subscriptionRestriction.companyCannotUntil", { action: actionText })
                    }
                </p>
                {isAdmin && (
                    <Link to="/settings/company?tab=billing" style={{ fontWeight: 600, color: "#0981c4" }}>
                        {t("app.subscriptionRestriction.updatePaymentInformation")}
                    </Link>
                )}
            </Message.Content>
        </Message>
    );
};

export default SubscriptionRestriction;

